const VALIDATION_STATES = {
  valid: 'valid',
  error: 'error',
  unprocessed: 'unprocessed',
};

export {
  VALIDATION_STATES,
};
